export default __webpack_public_path__ + "static/media/arrow.67157962.svg";